export default __webpack_public_path__ + "static/media/pg-icon4-secure-payment.4c789ae6.png";